import React, { useState, useEffect } from "react";

function PressureContextLegend(props) {
  // variable font size depending on the screen size
  const [windowWidth, setWindowWidth] = useState(0);
  const updateDimensions = () => {
    const windowWidth = window.innerWidth;
    setWindowWidth(windowWidth);
  };
  useEffect(() => {
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  const w = windowWidth > 1600 ? "25px" : "12px";

  const dashStyle = { height: "2px", width: w, background: "#860B0B" };

  return (
    <div className="card-footer">
      <div style={{ fontSize: "0.85rem" }}>
        <ul className="d-flex align-items-center justify-content-end">
          <li style={dashStyle} className="mr-2"></li>
          <li className="mr-4">Current pest pressure</li>
        </ul>
      </div>
    </div>
  );
}

export default PressureContextLegend;